module.exports = __webpack_public_path__ + "img/TORBA3.900efd43.jpg";